import Anchor from 'containers/ac-containers/ac-anchor';
import { useTranslation } from 'hooks/use-translation';
import { useModalContext } from 'hooks/useModalContext';
import React, { useEffect, useRef } from 'react';
import { SafeguardSection } from '../home/components';
import { CommentsSection, CurriculumSection, FreeSection, GrowthSection, LessonSection, OutcomeSection } from './components';
import styles from './styles.scss';



export default function HappyKidsPage() {
	const marqueeRef = useRef<{ cancelTimerMarquee: () => void }>(null)
	const { setTrigger, setEvent } = useModalContext()
	const { transData } = useTranslation('happyKids')
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className={styles['ac-container']}>
			<main className={styles['ac-happy-kids']}>
				<FreeSection onClick={() => {
					setTrigger(true)
					setEvent({ eventId: 'ACW_hk_getlesson' })
				}} />
				<LessonSection />
				<CurriculumSection />
				<GrowthSection />
				<OutcomeSection marqueeRef={marqueeRef} />
				<CommentsSection />
				<SafeguardSection >
					<div className={styles['safeguard-title']} dangerouslySetInnerHTML={{ __html: transData.title }} />
				</SafeguardSection>
				<Anchor className={styles.anchor} anchorText={'free'} onClick={() => {
					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					})

				}} eventId="PAF_bd784aa33f2d30d5">
					<img src="https://web-data.zmlearn.com/image/81QodeeXXoY9LvFE72vx4s/%E5%B0%8F%E6%9C%A8%E9%A9%AC%402x.png" alt="" loading='lazy' />
				</Anchor>
			</main>
		</div>
	);
}
